import { AuthorizationStatus } from '@flowio/api-constants';

export default function isAuthorizationApproved(auth: io.flow.v0.unions.Authorization): boolean {
  return [AuthorizationStatus.AUTHORIZED, AuthorizationStatus.REVIEW]
    .includes(auth.result.status as AuthorizationStatus);
}
